function getBrowserLocation(options = {}) {
	return new Promise((resolve, reject) => {
		if (!navigator.geolocation) {
			reject(new Error('Geolocation is not supported'));
			return;
		}

		navigator.geolocation.getCurrentPosition(
			(position) => {
				resolve({
					lat: position.coords.latitude,
					lng: position.coords.longitude,
					accuracy: position.coords.accuracy,
				});
			},
			reject,
			options,
		);
	});
}

const GetLocationPlugin = {
	install(app) {
		app.config.globalProperties.$getLocation = getBrowserLocation;
	},
};

export default GetLocationPlugin;
